import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    alerts: [],
    loading: false,
    error: null,
};

export const alertsSlice = createSlice({
    name: "alerts",
    initialState,
    reducers: {
        setAlerts: (state, action) => {
            state.alerts = action.payload;
            state.loading = false;
            state.error = null;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
        clearAlerts: (state) => {
            state.alerts = [];
            state.error = null;
        },
    },
});

export const { setAlerts, setLoading, setError, clearAlerts } = alertsSlice.actions;

export default alertsSlice.reducer;
